export default __webpack_public_path__ + "static/media/skillset-product.17ddf809.svg";